import React, { useState } from 'react'
import styles from "../style/components/modalAuth.module.css"
import axios from "axios"
import { Link, useHistory } from 'react-router-dom'

const ModalAuth = ({ setOpenAuthModal }) => {
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		email: "",
		password: "",
	})
	const [secondPass, setSecondPass] = useState("")
	const [errors, setErrors] = useState({})
	const [loginEmail, setLoginEmail] = useState("")
	const [loginPass, setLoginPass] = useState("")
	const [isLogin, setIsLogin] = useState(false)
	const [checkingCode, setCheckingCode] = useState(false)
	const [code, setCode] = useState("")
	const history = useHistory()

	const validateRegister = () => {
		const newErrors = {}

		if (!formData.firstName.trim()) newErrors.firstName = "Введите имя"
		if (!formData.lastName.trim()) newErrors.lastName = "Введите фамилию"
		if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) newErrors.email = "Некорректный email"
		if (formData.password.length < 6) newErrors.password = "Пароль должен быть не менее 6 символов"
		if (formData.password !== secondPass) newErrors.secondPass = "Пароли не совпадают"
		if (checkingCode && code.length !== 6) newErrors.code = "Введите код из 6 символов"

		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const validateLogin = () => {
		const newErrors = {}
		if (!loginEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) newErrors.loginEmail = "Некорректный email"
		if (!loginPass) newErrors.loginPass = "Введите пароль"

		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleChangeInput = (e) => {
		const { name, value } = e.target
		setFormData({ ...formData, [name]: value })
	}

	const handleSubmitRegister = async (e) => {
		e.preventDefault()
		if (!validateRegister()) return
		try {
			const res = await axios.post('https://rishat-tour.ru/api/auth/register', formData)
			setCheckingCode(true)
			console.log(res)
		} catch (e) {
			alert("Ошибка регистрации")
		}
	}

	const handleSubmitLogin = async (e) => {
		e.preventDefault()
		if (!validateLogin()) return
		try {
			const res = await axios.post('https://rishat-tour.ru/api/auth/login', {
				email: loginEmail, password: loginPass
			})
			localStorage.setItem("token", JSON.stringify(res.data))
			setOpenAuthModal(false)
			window.location.reload()
		} catch {
			alert("Неверные данные")
		}
	}

	const handleClickCheckCode = async (e) => {
		e.preventDefault()
		if (!code || code.length !== 6) {
			setErrors({ code: "Введите корректный код" })
			return
		}
		try {
			await axios.post('https://rishat-tour.ru/api/auth/verify-code', {
				email: formData.email,
				code
			})
			alert("Код подтвержден!")
			setIsLogin(false)
		} catch {
			alert("Неверный код")
		}
	}

	return (
		<div className={styles.modalAccount}>
			{isLogin ? (
				<div className={styles.modalReg}>
					<p>Регистрация</p>
					<form onSubmit={handleSubmitRegister}>
						<label>
							Имя
							<input type="text" name="firstName" placeholder='Введите Ваше имя' onChange={handleChangeInput} />
							{errors.firstName && <span>{errors.firstName}</span>}
						</label>

						<label>
							Фамилия
							<input type="text" name="lastName" placeholder='Введите вашу фамилию' onChange={handleChangeInput} />
							{errors.lastName && <span>{errors.lastName}</span>}
						</label>

						<label>
							Email
							<input type="email" name="email" placeholder='Введите почту' onChange={handleChangeInput} />
							{errors.email && <span>{errors.email}</span>}
						</label>

						<label>
							Пароль
							<input type="password" name="password" onChange={handleChangeInput} />
							{errors.password && <span>{errors.password}</span>}
						</label>

						<label>
							Повторите пароль
							<input type="password" onChange={(e) => setSecondPass(e.target.value)} />
							{errors.secondPass && <span>{errors.secondPass}</span>}
						</label>

						{checkingCode && (
							<>
								<label>
									Код с почты
									<input type="text" className={styles.check} onChange={(e) => setCode(e.target.value)} />
									{errors.code && <span>{errors.code}</span>}
								</label>
								<button onClick={handleClickCheckCode} className={styles.checkBtn}>Проверить код</button>
							</>
						)}

						<label className={styles.checkboxContainer}>
							<input type="checkbox" className={styles.checkboxContainerInput} required />
							<span>Продолжая, я соглашаюсь с <u>политикой конфиденциальности</u></span>
						</label>

						<button type="submit">Зарегистрироваться</button>
					</form>
				</div>
			) : (
				<div className={styles.modalAuth}>
					<p>Авторизация</p>
					<form onSubmit={handleSubmitLogin}>
						<label>
							Email
							<input type="email" placeholder='Введите почту' onChange={(e) => setLoginEmail(e.target.value)} />
							{errors.loginEmail && <span>{errors.loginEmail}</span>}
						</label>

						<label>
							Пароль <Link to='/forgot-pass' onClick={() => setOpenAuthModal(false)}><u>Забыли пароль?</u></Link>
							<input type="password" onChange={(e) => setLoginPass(e.target.value)} />
							{errors.loginPass && <span>{errors.loginPass}</span>}
						</label>

						<button type="submit">Войти</button>
						<p>Нет аккаунта? <button onClick={() => setIsLogin(true)}>Зарегистрируйтесь</button></p>
					</form>
				</div>
			)}
		</div>
	)
}

export default ModalAuth




















// import React, { useState } from 'react'
// import styles from "../style/components/modalAuth.module.css"
// import axios from "axios"
// import { Link } from 'react-router-dom'
// import { useLocation, useHistory } from 'react-router-dom';


// const ModalAuth = ({ setOpenAuthModal, openAuthModal }) => {

// 	const [formData, setFormData] = useState({
// 		firstName: "",
// 		lastName: "",
// 		email: "",
// 		password: "",
// 	})

// 	const [secondPass, setSecondPass] = useState("")
// 	const [isLogin, setIsLogin] = useState(false)

// 	const [loginEmail, setLoginEmail] = useState("")
// 	const [loginPass, setLoginPass] = useState("")

// 	const [checkingCode, setCheckingCode] = useState(false)
// 	const [code, setCode] = useState("")

// 	const history = useHistory();


// 	const handleSubmitRegister = async (e) => {
// 		e.preventDefault()
// 		try {
// 			if (secondPass !== formData.password) {
// 				alert("Пароли не совпадают")
// 				return
// 			}
// 			const res = await axios.post('https://rishat-tour.ru/api/auth/register', formData)
// 			setCheckingCode(true)
// 			console.log(res)
// 		} catch (e) {
// 			console.log(e)
// 		}
// 	}

// 	const handleChangeInput = (e) => {
// 		const { name, value } = e.target
// 		setFormData({ ...formData, [name]: value })
// 	}

// 	const handleSubmitLogin = async (e) => {
// 		try {
// 			e.preventDefault()
// 			const res = await axios.post('https://rishat-tour.ru/api/auth/login', {
// 				email: loginEmail, password: loginPass
// 			})

// 			localStorage.setItem("token", JSON.stringify(res.data))
// 			setOpenAuthModal(false)
// 			window.location.reload();
// 			console.log(res.data)
// 		} catch (e) {
// 			alert("Не удалось войти")
// 		}
// 	}

// 	const handleClickCheckCode = async (e) => {
// 		try {
// 			const res = axios.post('https://rishat-tour.ru/api/auth/verify-code', {
// 				email: formData.email,
// 				code:code
// 			})
// 			alert("Код подтвержден!")
// 			setIsLogin(false)
// 		} catch (e) {
// 			console.log(e)
// 		}
// 	}


	


// 	return (
// 		<div className={styles.modalAccount}>
// 			{isLogin ? <div className={styles.modalReg}>
// 				<img src="" alt="" />
// 				<p>Регистрация</p>
// 				<form onSubmit={handleSubmitRegister}>
// 					<label for="username">Имя <input type="text" id="username" name="firstName" placeholder='Введите Ваше имя' required onChange={handleChangeInput} /></label>

// 					<label for="surname">Фамилия <input type="text" id="surname" name="lastName" placeholder='Введите Вашу фамилию' required onChange={handleChangeInput} /></label>

// 					<label for="email">Email <input type="email" id="email" name="email" placeholder='Введите почту' required onChange={handleChangeInput} /></label>

// 					<label for="password">Пароль <input type="password" id="password" name="password" required onChange={handleChangeInput} /></label>

// 					<label for="password">Повторите пароль <input type="password" id="secondPassword" name="secondPassword" required onChange={(e) => setSecondPass(e.target.value)} /></label>

// 					{checkingCode && <> <label for="code">Код с почты <input type="text" id="code" name="code" required onChange={(e) => setCode(e.target.value)} /></label> <button onClick={handleClickCheckCode}> проверить код </button> </>}

// 					<label className={styles.checkboxContainer}>
// 						<input type="checkbox" className={styles.checkboxContainerInput} required />
// 						<span>
// 							Продолжая, я соглашаюсь с <u>политикой конфиденциальности</u>
// 						</span>
// 					</label>
// 					<button type="submit">Зарегистрироваться</button>
// 				</form>
// 			</div>
// 				:
// 				<div className={styles.modalAuth}>
// 					<img src="" alt="" />
// 					<p>Авторизация</p>
// 					<form onSubmit={handleSubmitLogin}>
// 						<label for="email">Email <input onChange={(e) => setLoginEmail(e.target.value)} type="email" placeholder='Введите почту' id="email" name="email" required /></label>

// 						<label for="password">Пароль <Link to='/forgot-pass' onClick={() => setOpenAuthModal(false)}><u>Забыли пароль?</u></Link> <input onChange={(e) => setLoginPass(e.target.value)} type="password" id="password" name="password" required /></label>

// 						<button type="submit">Войти</button>
// 						<p>Нет аккаунта? <button onClick={() => setIsLogin(true)}>Зарегистрируйтесь</button></p>
// 					</form>
// 				</div>
// 			}
// 		</div>
// 	)
// }

// export default ModalAuth